import styled from 'styled-components';

import css from './css';

const SecondaryButton = styled.button`
  ${css}
  background: ${Styles.color.white};
  border: 1px solid ${Styles.color.primary};
  border-radius: 9999rem;
  color: ${Styles.color.primary};
  cursor: pointer;
  font-family: ${Styles.fontFamily.base};
  font-size: 1rem;
  line-height: 1;
  padding: 1rem 1rem;
  user-select: none;
  width: 100%;

  &[disabled] {
    background: ${Styles.color.white} !important;
    border-color: ${Styles.color.grey.three};
    color: ${Styles.color.grey.three} !important;
    cursor: not-allowed;
  }

  &:active {
    background: ${Styles.color.primary};
    color: ${Styles.color.white};
    transform: scale(0.95);
    transition: transform 200ms ease-out;

    > svg {
      fill: ${Styles.color.white};
    }
  }
  &:hover {
    background: ${Styles.color.primary};
    color: ${Styles.color.white};
    fill: ${Styles.color.white};

    > svg {
      fill: ${Styles.color.white};
    }
  }
`;

export default SecondaryButton;
